var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('KeyValueList',{staticStyle:{"padding-left":"32px"},attrs:{"array":"","key-label":"Valor a almacenar","key-field":"value","value-label":"Texto a mostrar","value-field":"label"},model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }